(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    jQuery(function ($) {
      // Owl Carousel
      $('.owl-carousel').owlCarousel({
        loop: false,
        autoWidth: true,
        margin: 10,
        nav: true,
      });
      $('.owl-carousel .owl-dots').remove();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfw-about-hero"]) return;
  try {
    
  jQuery(function ($) {
    $('.read-more__btn').on('click', function () {
      $('.text-curtain').css('opacity', '0');
      $(this).css('visibility', 'hidden');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfw-blog-recipes"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    jQuery(function ($) {
      // Owl Carousel
      $('.owl-carousel').owlCarousel({
        loop: false,
        autoWidth: true,
        margin: 10,
        nav: true,
      });
      $('.owl-carousel .owl-dots').remove();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfw-home-hero"]) return;
  try {
    
  // Check if our dynamic image exists
  var dynamicImage = document.querySelector('#dynamic-image');

  if (dynamicImage) {
    adjustImageWidth(); // Run on page load

    window.addEventListener('resize', function () {
      adjustImageWidth();
    });
  }

  function adjustImageWidth() {
    var imageHeight = dynamicImage.offsetHeight;
    var aspectRatio = 864 / 662; // Image aspect ratio (width / height)
    var imageWidth = imageHeight * aspectRatio;
    dynamicImage.style.minWidth = imageWidth + 'px';
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfw-image-slider"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    jQuery(function ($) {
      // Owl Carousel
      $('.owl-carousel').owlCarousel({
        center: true,
        items: 1,
        loop: true,
        margin: 10,
        responsive: {
          950: {
            margin: 0,
          },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfw-market-stall"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    jQuery(function ($) {
      // Market Stall Accordion
      $('.content-chunk__footer-market-stall').on('click', '#accordion-header', function (e) {
        e.preventDefault();

        $(this).toggleClass('selected');
        $(this).next('.accordion-content').slideToggle(200);

        var accordionContent = $(this).next('.accordion-content');
        var accordionText = $('.open-close__text'); // Get the accordion text element

        if ($(this).hasClass('selected')) {
          accordionText.text('Close market details');
          setTimeout(function () {
            accordionContent.addClass('accord--open');
          }, 150); // Wait for 1 second before adding the class
        } else {
          accordionText.text('Expand market details');
          accordionContent.removeClass('accord--open');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

})();
